import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { FormPart } from '@modules/shared/components/FormPart';
import { TextInputField } from '@shared/fields/TextInputField';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { ICommunicateFormProps, NOTE_TYPE_OPTIONS } from './types';

export const CommunicateForm = ({loading, handleClose, values }: ICommunicateFormProps) => {
  const formConfig = useMemo(
    () => [
      {
        width: '50%',
        name: 'type',
        label: 'Types',
        options: NOTE_TYPE_OPTIONS,
        component: SelectAutocompleteField,
      },
      {
        width: '50%',
        name: 'notes',
        label: 'Notes',
        value: values?.notes,
        component: TextInputField,
      },
      {
        width: '50%',
        name: 'date',
        label: 'Date of update',
        value: values?.date,
        component: TextInputField,
        disabled: true,
      },
      {
        width: '50%',
        name: 'enteredBy',
        label: 'Entered By',
        value: values?.createdBy,
        component: TextInputField,
        disabled: true,
      },
    ],
    [values]
  );

  return (
    <>
      <PageContent>
        <Grid container spacing={12}>
          <Grid item md={12}>
            <FormPart config={formConfig} />
          </Grid>
        </Grid>
      </PageContent>

      <CommonButtonWrapper>
        <CancelButton
          onClick={handleClose}
        />
        <SaveButton isLoading={loading} />
      </CommonButtonWrapper>
    </>
  );
};
